export default __webpack_public_path__ + "static/media/rauchmelder_stockwerk2.914187df.png";